import { StepProps } from './Types'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'blaze-ui/icons'
import { MobileFieldsSection } from '../Form/MobileFieldsSection'
import { FieldSchema } from 'components/Wizards/Wizard/Form/Types'
import { useFormikContext } from 'formik'
import { CustomizeButton } from '../MobileWizard/components/RefineDetails/components/CustomizeButton'

export const Step = <Values extends object = {}>({ schema, submit, getSchemaField }: Partial<StepProps<Values>>) => {
  const { values, setValues } = useFormikContext<Values>()

  if (!schema || !submit || !getSchemaField) {
    return null
  }

  const {
    meta: { title, submitLabel = 'Continue', fullWidth },
    fields,
  } = schema.describe()

  const { fieldsArray, hasOverflowFields } = Object.entries(fields).reduce(
    (acc, [name]) => {
      const field = getSchemaField(name)
      if (!field) return acc

      const { meta } = field.describe()
      if (meta.overflow) {
        return { ...acc, hasOverflowFields: true }
      }

      return {
        ...acc,
        fieldsArray: [...acc.fieldsArray, [name, field] as [string, FieldSchema]],
      }
    },
    { fieldsArray: [] as [string, FieldSchema][], hasOverflowFields: false },
  )

  return (
    <>
      <MobileWizard.Content padding={fullWidth ? '10px 0 15px 0' : undefined}>
        <MobileWizard.Section padding={fullWidth ? '0 15px' : undefined}>
          <MobileWizard.Title>{title}</MobileWizard.Title>
        </MobileWizard.Section>
        <MobileWizard.Section gap={25}>
          <MobileFieldsSection fields={fieldsArray} />
        </MobileWizard.Section>
        {hasOverflowFields && (
          <MobileWizard.Section>
            <CustomizeButton
              schema={schema}
              initialValues={values}
              onSubmit={async (vals) => {
                setValues({ ...values, ...vals })
              }}
            />
          </MobileWizard.Section>
        )}
      </MobileWizard.Content>
      <MobileWizard.ButtonFooter>
        <Button size="lg" variant="primary" endIcon={ArrowRight} fullWidth onPress={submit}>
          {submitLabel}
        </Button>
      </MobileWizard.ButtonFooter>
    </>
  )
}
